<p-toast position="top-right"></p-toast>
<div class="p-g" *ngIf="requestor[0]?.requestType ==='Registration'">
    <br>
    <app-member-request-detail (reject)='reject()' [requestor]="requestor"></app-member-request-detail>
</div>

<div class="p-g" *ngIf="requestor[0]?.requestType ==='FeeSubmission'">
    <br>
    <app-fee-submission-request-detail (reject)='reject()' [requestor]="requestor"></app-fee-submission-request-detail>
</div>
<div class="p-g" *ngIf="requestor[0]?.requestType ==='OnlineRegistrationFee'">
    <br>
    <app-fee-submission-request-detail (reject)='reject()' [requestor]="requestor"></app-fee-submission-request-detail>
</div>

<div class="p-g" *ngIf="requestor[0]?.requestType ==='Visitor'">
    <br>
    <app-visitor-request-detail (reject)='reject()' [requestor]= "requestor"></app-visitor-request-detail>
</div>


<div class="p-g" *ngIf="requestor[0]?.requestType ==='FREEZE_REQUEST'">
    <br>
    <app-freeze-request-detail [requestor]="requestor" (reject)='reject()'></app-freeze-request-detail>

</div>